import axios from "axios";
import { toast } from "react-toastify";
import * as types from '../constants/ActionTypes';

//Urls
const formSubmitUrl =`${process.env.REACT_APP_API_URL}mobileshop/csaaboutus/enquiry`;

//Actions 

const formRequested=()=>({
    type:types.FORM_REQUEST

})
const formFailure=(errors)=>({
    type:types.FORM_FAILURE,
     errors
})
const formSuccess=(data)=>({
    type:types.FORM_SUCCESS,
     data
})

export const submitFormData=(options)=>{
  return dispatch=>{
      dispatch(formRequested());
      axios.post(formSubmitUrl,{
          options
      },
      {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
      })
      .then(res=>{
          if(res.data.ack === 'success'){
              dispatch(formSuccess(res.data.results))
              toast.success('Form has submited successfuly')
          }else if (res.data.ack === 'Failure'){
              dispatch(formFailure(res.data.status))
              toast.error(res.data.status.message)
          }

      })
.catch(err => {
    throw err;

})

  }

}